import { writable } from 'svelte/store';
export const tierScore = writable([0, 0, 0]);
export const productScore = writable([
    {
        id: 1,
        score: 0,
        name: 'That Green One',
        url: 'https://www.catharsiscoskincare.com/collections/frontpage/products/thatgreenone'
    },
    {
        id: 2,
        score: 0,
        name: 'Captured Fruit',
        url: 'https://www.catharsiscoskincare.com/collections/frontpage/products/capturedfruit'
    },
    {
        id: 3,
        score: 0,
        name: 'The Basics',
        url: 'https://www.catharsiscoskincare.com/collections/frontpage/products/thebasics'
    },
    {
        id: 4,
        score: 0,
        name: 'Essence of Moisture',
        url: 'https://www.catharsiscoskincare.com/collections/frontpage/products/essenceofmoisture'
    },
    {
        id: 5,
        score: 0,
        name: 'Eurek-A!',
        url: 'https://www.catharsiscoskincare.com/collections/frontpage/products/eurek-a'
    },
    {
        id: 6,
        score: 0,
        name: 'Time for Bed',
        url: 'https://www.catharsiscoskincare.com/collections/frontpage/products/timeforbed'
    }
]);
